import { SxProps } from '@mui/material'
import StylesHeaderCurrentFirmTitleServiceInterface
  from '~/src/components/layout/header/header-current-firm-title/styles/StylesHeaderCurrentFirmTitleServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesHeaderCurrentFirmTitleServiceStyleOne extends TemplateServiceStyleBase implements StylesHeaderCurrentFirmTitleServiceInterface {
  public getTitleSx(): SxProps {
    return {
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        cursor: 'pointer'
      }
    }
  }
}
